// Class: openfl.utils.IDataInput

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../hxClasses_stub").default;
var $hxEnums = require("./../../hxEnums_stub").default;

// Constructor

var IDataInput = function() {}

// Meta

IDataInput.__name__ = "openfl.utils.IDataInput";
IDataInput.__isInterface__ = true;
IDataInput.prototype = {
	
};
IDataInput.prototype.__class__ = IDataInput.prototype.constructor = $hxClasses["openfl.utils.IDataInput"] = IDataInput;

// Init



// Statics




// Export

exports.default = IDataInput;